import { DM_INBOX_SEARCH_MAX_LENGTH } from '../../../services/dmNotifications';

// Clamped so a pasted overlong link can't send a search the backend rejects.
export function parseInboxSearch(raw: string | null): string {
    return (raw ?? '').trim().slice(0, DM_INBOX_SEARCH_MAX_LENGTH);
}

// Only a list's own params travel between it and its patient view.
export function pickListSearch(searchParams: URLSearchParams, keys: readonly string[]): string {
    const picked = new URLSearchParams(
        [...searchParams.entries()].filter(([key]) => keys.includes(key))
    );
    const query = picked.toString();
    return query ? `?${query}` : '';
}

// Router state a list sets when it opens a view, so the view's Back can pop history instead.
export function hasRouterFlag(state: unknown, flag: string): boolean {
    return (
        typeof state === 'object' &&
        state !== null &&
        (state as Record<string, unknown>)[flag] === true
    );
}
